// Required by react-apple-signin-auth@0.0.12, which expects a global regeneratorRuntime
import 'regenerator-runtime/runtime';

import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';

import '@/shared/config/i18n/i18n';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(<App />);
